import React from 'react';

export default () => <p>You have been logged out.</p>;
